import { render, staticRenderFns } from "./Designers.vue?vue&type=template&id=2a28a148&scoped=true"
import script from "./Designers.vue?vue&type=script&lang=js"
export * from "./Designers.vue?vue&type=script&lang=js"
import style0 from "./Designers.vue?vue&type=style&index=0&id=2a28a148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a28a148",
  null
  
)

export default component.exports